import React from "react";

interface CriterionLabelProps {
	label: string;
	prefix?: string;
}

export const CriterionLabel = ({ label, prefix }: CriterionLabelProps) => {
	if (!label) {
		return null;
	}

	return (
		<span className="criterion__label">
			{prefix && (
				<span className="criterion__label__prefix">{prefix}</span>
			)}
			{label}
		</span>
	);
};
